import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/Listing/Listing.styles';
import SingleImage from '@features/cms/components/categories/CategoryGalleryBlock/components/SingleImage/SingleImage';
import { ICategoryGalleryBlockImage } from '@features/cms/typescript';
type PropsType = {
  images: ICategoryGalleryBlockImage[][];
};
const Listing = ({
  images
}: PropsType) => <div sx={styles.imagesContainer}>
    <div>
      {images.map((row, index) => <div key={`imageRow_${index}`} sx={styles.imageRow(row.map(image => image.orientation))}>
          {row.map(image => <div sx={styles.image} key={image.image.path}>
              <SingleImage image={image} />
            </div>)}
        </div>)}
    </div>
  </div>;
export default Listing;